import {tassign} from 'app/common/utils';
import {FeatureEx} from '../../../../models/features/features';
import {Component, Inject, Input} from '@angular/core';
import {FeatureFilterState} from 'app/models/features/feature_const';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {ApplicationSpecActions} from "../../../../Redux/Actions/application-spec-actions";
import {ActionsService} from "../../../../Redux/Actions/actions.service";

@Component({
  selector: 'edsng-feature-dialog',
  templateUrl: './feature-dialog.component.html',
  styleUrls: ['./feature-dialog.component.css']
})
export class FeatureDialogComponent {

  @Input() feature: FeatureEx;

  public filterState = FeatureFilterState;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private actSrvc: ActionsService, public dialog: MatDialog) {
  }

  filterFeature(val: FeatureFilterState) {
    const featEx: FeatureEx = tassign(this.feature, {stateFilter: val});
    this.dialog.closeAll();
    this.actSrvc.sendAction(ApplicationSpecActions.updateFeature(featEx));
  }

}
